"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectLastYear = exports.selectThisYear = exports.selectLastMonth = exports.selectThisMonth = exports.selectLastWeek = exports.selectThisWeek = exports.selectYesterday = exports.selectToday = exports.months = exports.getDate = void 0;
var getDate = function (date) {
    var options = { year: 'numeric', month: 'short', day: 'numeric' };
    var result = date === null || date === void 0 ? void 0 : date.toLocaleDateString('en-us', options);
    return result;
};
exports.getDate = getDate;
exports.months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
var selectToday = function () { return new Date(); };
exports.selectToday = selectToday;
var selectYesterday = function () {
    var date = new Date();
    date.setDate(date.getDate() - 1);
    return date;
};
exports.selectYesterday = selectYesterday;
var selectThisWeek = function () {
    var curr = new Date();
    var first = curr.getDate() - curr.getDay() + 1;
    var firstDay = new Date(curr.setDate(first));
    var lastDay = new Date(curr.setDate(curr.getDate() + 6));
    return [firstDay, lastDay];
};
exports.selectThisWeek = selectThisWeek;
var selectLastWeek = function () {
    var curr = new Date();
    var first = curr.getDate() - curr.getDay() - 6;
    var firstDay = new Date(curr.setDate(first));
    var lastDay = new Date(curr.setDate(curr.getDate() + 6));
    return [firstDay, lastDay];
};
exports.selectLastWeek = selectLastWeek;
var selectThisMonth = function () {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return [firstDay, lastDay];
};
exports.selectThisMonth = selectThisMonth;
var selectLastMonth = function () {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
    return [firstDay, lastDay];
};
exports.selectLastMonth = selectLastMonth;
var selectThisYear = function () {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), 0, 1);
    var lastDay = new Date(date.getFullYear(), 12, 0);
    return [firstDay, lastDay];
};
exports.selectThisYear = selectThisYear;
var selectLastYear = function () {
    var date = new Date();
    var firstDay = new Date(date.getFullYear() - 1, 0, 1);
    var lastDay = new Date(date.getFullYear() - 1, 12, 0);
    return [firstDay, lastDay];
};
exports.selectLastYear = selectLastYear;
